import { useMediaQuery } from '@chakra-ui/react';

const MOBILE_SCREEN_SIZE = 768;

export const useScreen = () => {
  const [isMobile] = useMediaQuery(`(max-width: ${MOBILE_SCREEN_SIZE}px)`);

  return { isMobile };
};
